export function dotTrim(string, maxLength) {
  if (string.length < maxLength) {
    return string;
  }

  string = string.substr(0, maxLength);

  return `${string}..`;
}

export function repeat(string, repeatCount) {
  if (repeatCount < 0) {
    return '';
  }

  let repeatedString = '';

  for (let i = 0; i < repeatCount; i += 1) {
    repeatedString += string;
  }

  return repeatedString;
}

export function padLeft(string, length, padCharacter = ' ') {
  const repeatCount = length - string.length;

  if (repeatCount <= 0) {
    return string;
  }

  return repeat(padCharacter, repeatCount) + string;
}

export function padRight(string, length, padCharacter = ' ') {
  const repeatCount = length - string.length;

  if (repeatCount <= 0) {
    return string;
  }

  return string + repeat(padCharacter, repeatCount);
}
